module.exports = {
	"questions": [
		{
			"id": 7,
			"question": "What is your main area of responsibility?",
			"options": [
				{
					"tag": "marketing",
					"toQuestion": 8
				},
				{
					"tag": "sales",
					"toQuestion": 9
				},
				{
					"tag": "customer-support",
					"toQuestion": 10
				},
				{
					"tag": "founder-finance",
					"toQuestion": 11
				},
				{
					"tag": "human-resources",
					"toQuestion": 12
				},
				{
					"tag": "product-engineering",
					"active": false
				}
			]
		},
		{
			"id": 8,
			"question": "What are you focused on improving?",
			"options": [
				{
					"tag": "customer-acquisition",
					"toQuestion": 0
				},
				{
					"tag": "product-marketing",
					"toQuestion": 0
				},
				{
					"tag": "brand-awareness",
					"toQuestion": 0
				},
				{
					"tag": "conversion-optimization",
					"toQuestion": 0
				},
				{
					"tag": "overall-marketing-performance",
					"toQuestion": 0
				}
			]
		},
		{
			"id": 9,
			"question": "What are you focused on improving?",
			"options": [
				{
					"tag": "opportunity-generation",
					"toQuestion": 0
				},
				{
					"tag": "closing-deals",
					"toQuestion": 0
				},
				{
					"tag": "customer-upsell",
					"toQuestion": 0
				},
				{
					"tag": "overall-sales-performance",
					"toQuestion": 0
				}
			]
		},
		{
			"id": 10,
			"question": "What are you focused on improving?",
			"options": [
				{
					"tag": "onboarding",
					"toQuestion": 0
				},
				{
					"tag": "support",
					"toQuestion": 0
				},
				{
					"tag": "upsell-retention",
					"toQuestion": 0
				},
				{
					"tag": "online-knowledge-base",
					"toQuestion": 0
				},
				{
					"tag": "overall-customer-success",
					"toQuestion": 0
				}
			]
		},
		{
			"id": 11,
			"question": "What stage is the company at?",
			"options": [
				{
					"tag": "startup",
					"toQuestion": 0
				},
				{
					"tag": "growth",
					"toQuestion": 0
				},
				{
					"tag": "profitability",
					"toQuestion": 0
				}
			]
		},
		{
			"id": 12,
			"question": "What are you focused on improving?",
			"options": [
				{
					"tag": "overall-human-resources-performance",
					"toQuestion": 0
				},
				{
					"tag": "recruitment",
					"toQuestion": 0
				}
			]
		}
	],
	"tags": [
		{
			"id": "saas",
			"name": "SaaS"
		},
		{
			"id": "marketing",
			"name": "Marketing / Growth",
			"icon": "/icons/marketing.svg"
		},
		{
			"id": "customer-acquisition",
			"name": "Customer Acquisition",
			"icon": "/icons/customer-acquisition.svg"
		},
		{
			"id": "product-marketing",
			"name": "Product Marketing / Positioning",
			"icon": "/icons/product-marketing.svg"
		},
		{
			"id": "brand-awareness",
			"name": "Brand Awareness",
			"icon": "/icons/brand-awareness.svg"
		},
		{
			"id": "conversion-optimization",
			"name": "Conversion Optimization",
			"icon": "/icons/conversion-optimization.svg"
		},
		{
			"id": "overall-marketing-performance",
			"name": "Overall Marketing Performance",
			"icon": "/icons/overall-marketing-performance.svg"
		},
		{
			"id": "founder-finance",
			"name": "Founder / Finance",
			"icon": "/icons/founder.svg"
		},
		{
			"id": "startup",
			"name": "Startup",
			"icon": "/icons/startup.svg"
		},
		{
			"id": "growth",
			"name": "Growth",
			"icon": "/icons/growth.svg"
		},
		{
			"id": "profitability",
			"name": "Profitability",
			"icon": "/icons/profitability.svg"
		},
		{
			"id": "sales",
			"name": "Sales",
			"icon": "/icons/sales.svg"
		},
		{
			"id": "opportunity-generation",
			"name": "Opportunity Generation",
			"icon": "/icons/opportunity-generation.svg"
		},
		{
			"id": "closing-deals",
			"name": "Closing Deals",
			"icon": "/icons/closing-deals.svg"
		},
		{
			"id": "customer-upsell",
			"name": "Customer Upsell / Retention",
			"icon": "/icons/customer-upsell.svg"
		},
		{
			"id": "overall-sales-performance",
			"name": "Overall Sales Performance",
			"icon": "/icons/overall-sales-performance.svg"
		},
		{
			"id": "customer-support",
			"name": "Customer Support / Success",
			"icon": "/icons/customer-support.svg"
		},
		{
			"id": "human-resources",
			"name": "Human Resources",
			"icon": "/icons/human-resources.svg"
		},
		{
			"id": "product-engineering",
			"name": "Product and Engineering",
			"icon": "/icons/product-engineering.svg"
		},
		{
			"id": "onboarding",
			"name": "Onboarding",
			"icon": "/icons/onboarding.svg"
		},
		{
			"id": "support",
			"name": "Support",
			"icon": "/icons/support.svg"
		},
		{
			"id": "upsell-retention",
			"name": "Upsell / Retention",
			"icon": "/icons/upsell-retention.svg"
		},
		{
			"id": "online-knowledge-base",
			"name": "Online Knowledge Base",
			"icon": "/icons/online-knowledgebase.svg"
		},
		{
			"id": "overall-customer-success",
			"name": "Overall Customer Success",
			"icon": "/icons/overall-customer-success.svg"
		},
		{
			"id": "overall-human-resources-performance",
			"name": "Overall Human Resources performance",
			"icon": "/icons/overall-customer-success.svg"
		},
		{
			"id": "recruitment",
			"name": "Recruitment",
			"icon": "/icons/recruitment.svg"
		}
	],
	"metrics": [
		{
			"id": "employee-net-promoter-score",
			"name": "Employee Net Promoter Score",
			"tags": [
				"human-resources",
				"overall-human-resources-performance"
			],
			"images": [
				"/number.png",
				"/line.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/employee-net-promoter-score/"
		},
		{
			"id": "male-to-female-ratio",
			"name": "Male to Female Ratio",
			"tags": [
				"human-resources",
				"overall-human-resources-performance"
			],
			"images": [
				"/number.png",
				"/bar.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/male-to-female-ratio/"
		},
		{
			"id": "new-starters-per-month",
			"name": "New Starters Per Month",
			"tags": [
				"human-resources",
				"overall-human-resources-performance"
			],
			"images": [
				"/number.png",
				"/bar.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/new-starters-per-month/"
		},
		{
			"id": "permanent-to-freelance-staff-ratio",
			"name": "Permanent to Freelance Staff Ratio",
			"tags": [
				"human-resources",
				"overall-human-resources-performance"
			],
			"images": [
				"/leaderboard.png",
				"/bar.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/permanent-to-freelance-staff-ratio/"
		},
		{
			"id": "training-expenses",
			"name": "Training Expenses",
			"tags": [
				"human-resources",
				"overall-human-resources-performance"
			],
			"images": [
				"/number.png",
				"/bar.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/training-expenses/"
		},
		{
			"id": "application-completion-rate",
			"name": "Application Completion Rate",
			"tags": [
				"human-resources",
				"recruitment"
			],
			"images": [
				"/number.png",
				"/line.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/application-completion-rate/"
		},
		{
			"id": "cost-per-hire",
			"name": "Cost Per Hire",
			"tags": [
				"human-resources",
				"recruitment"
			],
			"images": [
				"/number.png",
				"/bar.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/cost-per-hire/"
		},
		{
			"id": "new-hire-turnover-rate",
			"name": "New Hire Turnover Rate",
			"tags": [
				"human-resources",
				"recruitment"
			],
			"images": [
				"/number.png",
				"/line.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/new-hire-turnover-rate/"
		},
		{
			"id": "source-of-hire",
			"name": "Source of Hire",
			"tags": [
				"human-resources",
				"recruitment"
			],
			"images": [
				"/leaderboard.png",
				"/bar.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/source-of-hire/"
		},
		{
			"id": "time-to-fill",
			"name": "Time to Fill",
			"tags": [
				"human-resources",
				"recruitment"
			],
			"images": [
				"/number.png",
				"/line.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/time-to-fill/"
		},
		{
			"id": "yield-ratio",
			"name": "Yield Ratio",
			"tags": [
				"human-resources",
				"recruitment"
			],
			"images": [
				"/number.png",
				"/leaderboard.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/hr-kpis/yield-ratio/"
		},
		{
			"id": "conversations-per-teammate",
			"name": "Conversations Per Teammate",
			"tags": [
				"customer-support",
				"support"
			],
			"images": [
				"/column.png",
				"/leaderboard.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/customer-support-kpis/conversations-per-teammate/"
		},
		{
			"id": "first-response-time",
			"name": "First Response Time",
			"tags": [
				"customer-support",
				"overall-customer-success",
				"onboarding",
				"support"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/customer-support-kpis/first-response-time/"
		},
		{
			"id": "customer-satisfaction-csat",
			"name": "Customer Satisfaction (CSAT)",
			"tags": [
				"saas",
				"sales",
				"customer-upsell",
				"customer-support",
				"upsell-retention",
				"onboarding",
				"support"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/customer-support-kpis/customer-satisfaction-csat/"
		},
		{
			"id": "ticket-backlog",
			"name": "Ticket Backlog",
			"tags": [
				"saas",
				"customer-support",
				"support"
			],
			"images": [
				"/line.png",
				"/column.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/customer-support-kpis/ticket-backlog/"
		},
		{
			"id": "ticket-volume",
			"name": "Ticket Volume",
			"tags": [
				"saas",
				"customer-support",
				"support"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/customer-support-kpis/ticket-volume/"
		},
		{
			"id": "average-order-value",
			"name": "Average Order Value",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/ecommerce-kpis/average-order-value/"
		},
		{
			"id": "customer-acquisition-cost",
			"name": "Customer Acquisition Cost (CAC)",
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/ecommerce-kpis/customer-acquisition-cost/"
		},
		{
			"id": "gross-profit-margin",
			"name": "Gross Profit Margin",
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/ecommerce-kpis/gross-profit-margin/"
		},
		{
			"id": "percent-returning-customers",
			"name": "Percent Returning Customers",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/ecommerce-kpis/percent-returning-customers/"
		},
		{
			"id": "revenue-by-traffic",
			"name": "Revenue by Traffic Source",
			"tags": [
				"saas",
				"marketing",
				"customer-acquisition",
				"conversion-optimization"
			],
			"images": [
				"/column.png",
				"/leaderboard.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/ecommerce-kpis/revenue-by-traffic-source/"
		},
		{
			"id": "shopping-cart-abandonment",
			"name": "Shopping Cart Abandonment Rate",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/ecommerce-kpis/shopping-cart-abandonment-rate/"
		},
		{
			"id": "brand-recall",
			"name": "Brand Recall",
			"tags": [
				"saas",
				"marketing",
				"brand-awareness",
				"overall-marketing-performance"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/brand-recall/"
		},
		{
			"id": "cost-per-acquisition",
			"name": "Cost Per Acquisition (CPA)",
			"tags": [
				"saas",
				"marketing",
				"customer-acquisition"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/cost-per-acquisition-cpa/"
		},
		{
			"id": "ltv:cac-ratio",
			"name": "LTV:CAC Ratio",
			"tags": [
				"saas",
				"marketing",
				"overall-marketing-performance",
				"founder-finance",
				"growth"
			],
			"images": [
				"/number.png",
				"/bar.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/ltv-cac-ratio/"
		},
		{
			"id": "marketing-return-on",
			"name": "Marketing Return On Investment (ROI)",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/marketing-roi/"
		},
		{
			"id": "net-promoter-score",
			"name": "Net Promoter Score (NPS)",
			"tags": [
				"saas",
				"marketing",
				"product-marketing",
				"overall-marketing-performance",
				"sales",
				"customer-upsell",
				"customer-support",
				"onboarding",
				"support",
				"upsell-retention",
				"overall-customer-success",
				"founder-finance",
				"growth"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/net-promoter-score-nps/"
		},
		{
			"id": "viral-coefficient",
			"name": "Viral Coefficient",
			"tags": [
				"saas",
				"marketing",
				"customer-acquisition",
				"conversion-optimization"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/viral-coefficient/"
		},
		{
			"id": "website-conversion-rate",
			"name": "Website Conversion Rate",
			"tags": [
				"saas",
				"marketing",
				"product-marketing",
				"brand-awareness",
				"conversion-optimization"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/website-conversion-rate/"
		},
		{
			"id": "website-traffic-growth",
			"name": "Website Traffic Growth",
			"tags": [
				"saas",
				"marketing",
				"customer-acquisition",
				"brand-awareness",
				"overall-marketing-performance"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/marketing-kpis/website-traffic-growth/"
		},
		{
			"id": "app-store-ranking",
			"name": "App Store Ranking",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/mobile-app-kpis/app-ranking/"
		},
		{
			"id": "average-revenue-per",
			"name": "Average Revenue Per User (ARPU)",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/mobile-app-kpis/average-revenue-per-user-arpu/"
		},
		{
			"id": "cost-per-install",
			"name": "Cost Per Install (CPI)",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/mobile-app-kpis/cost-per-install/"
		},
		{
			"id": "retention-rate",
			"name": "Retention Rate",
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/mobile-app-kpis/retention-rate/"
		},
		{
			"id": "session-length",
			"name": "Session Length",
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/mobile-app-kpis/session-length/"
		},
		{
			"id": "average-revenue-per",
			"name": "Average Revenue Per Account (ARPA)",
			"tags": [
				"founder-finance",
				"startup"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/saas-kpis/average-revenue-per-account-arpa/"
		},
		{
			"id": "cac-payback-period",
			"name": "CAC Payback Period",
			"tags": [
				"saas",
				"marketing",
				"overall-marketing-performance",
				"founder-finance",
				"profitability"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/saas-kpis/cac-payback-period/"
		},
		{
			"id": "expansion-mrr-rate",
			"name": "Expansion MRR Rate",
			"tags": [
				"saas",
				"sales",
				"customer-upsell",
				"customer-support",
				"overall-customer-success",
				"founder-finance",
				"growth",
				"upsell-retention"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/saas-kpis/expansion-mrr-rate/"
		},
		{
			"id": "gross-mrr-churn",
			"name": "Gross MRR Churn Rate",
			"tags": [
				"saas",
				"sales",
				"customer-upsell"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/saas-kpis/gross-mrr-churn-rate/"
		},
		{
			"id": "lead-velocity-rate",
			"name": "Lead Velocity Rate",
			"tags": [
				"saas",
				"marketing",
				"customer-acquisition",
				"overall-marketing-performance",
				"founder-finance",
				"growth"
			],
			"images": [
				"/line.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/saas-kpis/lead-velocity-rate/"
		},
		{
			"id": "net-mrr-churn",
			"name": "Net MRR Churn Rate",
			"tags": [
				"saas",
				"sales",
				"customer-upsell",
				"customer-support",
				"overall-customer-success",
				"founder-finance",
				"growth",
				"profitability",
				"marketing",
				"product-marketing",
				"upsell-retention"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/saas-kpis/net-mrr-churn-rate/"
		},
		{
			"id": "activity-per-rep",
			"name": "Activity Per Rep",
			"tags": [
				"saas",
				"sales",
				"opportunity-generation"
			],
			"images": [
				"/column.png",
				"/leaderboard.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/activity-per-rep/"
		},
		{
			"id": "average-follow-up-attempts",
			"name": "Average Follow-Up Attempts",
			"tags": [
				"saas",
				"sales",
				"opportunity-generation"
			],
			"images": [
				"/number.png",
				"/leaderboard.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/average-follow-up-attempts/"
		},
		{
			"id": "average-purchase-value",
			"name": "Average Purchase Value",
			"tags": [
				"saas",
				"marketing",
				"product-marketing",
				"conversion-optimization",
				"sales",
				"closing-deals",
				"overall-sales-performance"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/average-purchase-value/"
		},
		{
			"id": "average-sales-cycle",
			"name": "Average Sales Cycle Length",
			"tags": [
				"saas",
				"sales",
				"closing-deals",
				"overall-sales-performance"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/average-sales-cycle-length/"
		},
		{
			"id": "lead-response-time",
			"name": "Lead Response Time",
			"tags": [
				"saas",
				"sales",
				"opportunity-generation"
			],
			"images": [
				"/line.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/lead-response-time/"
		},
		{
			"id": "marketing-qualified-lead",
			"name": "Marketing Qualified Lead (MQL) to Sales Qualified Lead (SQL) Conversion Rate",
			"tags": [
				"saas",
				"marketing",
				"product-marketing",
				"sales",
				"opportunity-generation",
				"overall-sales-performance"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/mql-to-sql-conversion-rate/"
		},
		{
			"id": "pipeline-volume-vs",
			"name": "Pipeline Volume vs Goal",
			"tags": [
				"saas",
				"marketing",
				"customer-acquisition",
				"sales",
				"opportunity-generation",
				"closing-deals",
				"overall-sales-performance"
			],
			"images": [
				"/geckometer.png",
				"/column.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/pipeline-volume-vs-goal/"
		},
		{
			"id": "sales-qualified-lead",
			"name": "Sales Qualified Lead (SQL) to Win Conversion Rate",
			"tags": [
				"saas",
				"marketing",
				"product-marketing",
				"sales",
				"opportunity-generation",
				"closing-deals",
				"overall-sales-performance"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/sales-kpis/sql-to-win-conversion-rate/"
		},
		{
			"id": "activation-rate",
			"name": "Activation Rate",
			"tags": [
				"saas",
				"marketing",
				"conversion-optimization",
				"customer-support",
				"onboarding",
				"founder-finance",
				"startup"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/startup-kpis/activation-rate/"
		},
		{
			"id": "burn-rate",
			"name": "Burn Rate",
			"tags": [
				"saas",
				"founder-finance",
				"startup",
				"profitability"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/startup-kpis/burn-rate/"
		},
		{
			"id": "customer-churn-rate",
			"name": "Customer Churn Rate",
			"tags": [
				"saas",
				"sales",
				"customer-upsell",
				"customer-support",
				"upsell-retention",
				"overall-customer-success",
				"founder-finance",
				"startup"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/startup-kpis/customer-churn-rate/"
		},
		{
			"id": "daily-active-users",
			"name": "Daily Active Users (DAU) to Monthly Active Users (MAU) Rate",
			"tags": [
				"founder-finance",
				"startup"
			],
			"images": [
				"/line.png",
				"/number.png"
			],
			"link": "https://www.geckoboard.com/learn/kpi-examples/startup-kpis/dau-mau-ratio/"
		},
		{
			"id": "press-clippings",
			"name": "Press Clippings",
			"link": "https://www.geckoboard.com/learn/kpi-examples/press-clippings/",
			"tags": [
				"marketing",
				"brand-awareness"
			],
			"images": [
				"/line.png",
				"/column.png"
			]
		},
		{
			"id": "social-media-mentions",
			"name": "Social Media Mentions",
			"link": "https://www.geckoboard.com/learn/kpi-examples/social-media-mentions/",
			"tags": [
				"marketing",
				"brand-awareness"
			],
			"images": [
				"/line.png",
				"/column.png"
			]
		},
		{
			"id": "branded-search-traffic",
			"name": "Branded Search Traffic",
			"link": "https://www.geckoboard.com/learn/kpi-examples/branded-search-traffic/",
			"tags": [
				"marketing",
				"brand-awareness"
			],
			"images": [
				"/line.png",
				"/column.png"
			]
		},
		{
			"id": "signup-to-subscriber",
			"name": "Signup to Subscriber Conversion Rate",
			"link": "https://www.geckoboard.com/learn/kpi-examples/signup-to-subscriber-conversion-rate/",
			"tags": [
				"marketing",
				"conversion-optimization",
				"customer-support",
				"onboarding",
				"overall-customer-success"
			],
			"images": [
				"/line.png",
				"/number.png"
			]
		},
		{
			"id": "mrr-closed-vs",
			"name": "MRR Closed vs Quota",
			"link": "https://www.geckoboard.com/learn/kpi-examples/mrr-closed-vs-quota/",
			"tags": [
				"sales",
				"closing-deals",
				"overall-sales-performance"
			],
			"images": [
				"/leaderboard.png",
				"/number.png"
			]
		},
		{
			"id": "completion-rate",
			"name": "Completion Rate",
			"link": "https://www.geckoboard.com/learn/kpi-examples/completion-rate/",
			"tags": [
				"customer-support",
				"onboarding"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			]
		},
		{
			"id": "customer-lifetime-value",
			"name": "Customer Lifetime Value (LTV)",
			"link": "http://geckoboard.com/learn/kpi-examples/customer-lifetime-value-ltv/",
			"tags": [
				"customer-support",
				"upsell-retention",
				"founder-finance",
				"profitability"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			]
		},
		{
			"id": "most-common-issue",
			"name": "Most Common Issue",
			"link": "http://geckoboard.com/learn/kpi-examples/most-common-issues/",
			"tags": [
				"customer-support",
				"online-knowledge-base"
			],
			"images": [
				"/bar.png",
				"/leaderboard.png"
			]
		},
		{
			"id": "quick-ratio",
			"name": "Quick Ratio",
			"link": "http://geckoboard.com/learn/kpi-examples/quick-ratio/",
			"tags": [
				"founder-finance",
				"profitability"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			]
		},
		{
			"id": "gross-margin",
			"name": "Gross Margin",
			"link": "http://geckoboard.com/learn/kpi-examples/gross-margin/",
			"tags": [
				"founder-finance",
				"profitability"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			]
		},
		{
			"id": "knowledge-base-views",
			"name": "Knowledge Base Views",
			"link": "http://geckoboard.com/learn/kpi-examples/knowledge-base-views/",
			"tags": [
				"customer-support",
				"online-knowledge-base"
			],
			"images": [
				"/line.png",
				"/number.png"
			]
		},
		{
			"id": "pages-viewed-per",
			"name": "Pages Viewed per Session",
			"link": "http://geckoboard.com/learn/kpi-examples/pages-viewed-per-session/",
			"tags": [
				"customer-support",
				"online-knowledge-base"
			],
			"images": [
				"/line.png",
				"/number.png"
			]
		},
		{
			"id": "ratio-of-views",
			"name": "Ratio of Views to Submitted tickets",
			"link": "http://geckoboard.com/learn/kpi-examples/ratio-of-views-vs-tickets-submitted/",
			"tags": [
				"customer-support",
				"online-knowledge-base"
			],
			"images": [
				"/number.png",
				"/geckometer.png"
			]
		},
		{
			"id": "percentage-of-positive",
			"name": "Percentage of Positive Votes ",
			"link": "http://geckoboard.com/learn/kpi-examples/percentage-of-positive-votes/",
			"tags": [
				"customer-support",
				"online-knowledge-base"
			],
			"images": [
				"/column.png",
				"/leaderboard.png"
			]
		},
		{
			"id": "bounce-rate",
			"name": "Bounce Rate",
			"link": "http://geckoboard.com/learn/kpi-examples/bounce-rate/",
			"tags": [
				"customer-support",
				"online-knowledge-base"
			],
			"images": [
				"/line.png",
				"/number.png"
			]
		},
		{
			"id": "percentage-of-new",
			"name": "Percentage of New Users",
			"link": "http://geckoboard.com/learn/kpi-examples/percentage-of-new-users/",
			"tags": [
				"customer-support",
				"online-knowledge-base"
			],
			"images": [
				"/line.png",
				"/number.png"
			]
		},
		{
			"id": "revenue-growth-rate",
			"name": "Revenue Growth Rate",
			"link": "http://geckoboard.com/learn/kpi-examples/startup-kpis/revenue-growth-rate/",
			"tags": [
				"founder-finance",
				"startup",
				"growth"
			],
			"images": [
				"/line.png",
				"/number.png"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/data.json
// module id = 290
// module chunks = 0